import React from "react"
import moment from "moment"
import { useNavigate } from "react-router-dom"

export default function EvaluationReportsTable({ isloading, evaluationsData }) {
  const navigate = useNavigate()

  const getEvaluationChatId = evaluation =>
    evaluation.chat?._id || evaluation.chat?.id || evaluation.chat?.chatID

  // Helper function to truncate message to ~15 words (3 lines ? 5 words)
  const truncateMessage = (message, maxWords = 15) => {
    if (!message) return "-"
    const words = message.split(/\s+/)
    if (words.length <= maxWords) return message
    return words.slice(0, maxWords).join(" ") + "..."
  }

  const handleViewChat = evaluation => {
    const chatId = getEvaluationChatId(evaluation)

    if (chatId) {
      navigate(`/chat/${chatId}`)
    }
  }

  return (
    <div className="table-container table-performance m-0 p-0">
      {isloading ? (
        <div className="loading">
          <div className="spinner-border"></div>
        </div>
      ) : (
        <table className="">
          <thead className="text-center">
            <tr>
              <th rowSpan="2">Chat</th>
              <th rowSpan="2">User</th>
              <th colSpan="2">Feedback</th>
              <th rowSpan="2">Feedback Message</th>
              <th rowSpan="2">Date</th>
              <th rowSpan="2">Actions</th>
            </tr>
            <tr>
              <th>هل تم خدمتك بشكل جيد ومرضٍ؟</th>
              <th>كيف تقيم تجربتك العامة مع خدمة العملاء؟</th>
            </tr>
          </thead>
          {evaluationsData && evaluationsData.length > 0 ? (
            <tbody>
              {evaluationsData.map((evaluation, index) => (
                <tr key={evaluation._id || index}>
                  <td className="text-center">
                    {evaluation.chat?.client || "-"}
                  </td>
                  <td className="text-center">
                    {evaluation.feedbackUser
                      ? `${evaluation.feedbackUser.firstName || ""} ${
                          evaluation.feedbackUser.lastName || ""
                        }`.trim() || "-"
                      : "-"}
                  </td>
                  <td className="text-center">
                    {evaluation.feedback?.[0]?.text || "-"}
                  </td>
                  <td className="text-center">
                    {evaluation.feedback?.[1]?.text || "-"}
                  </td>
                  <td
                    className="text-center"
                    title={evaluation.feedbackMessage || ""}
                    style={{
                      maxWidth: "200px",
                      cursor:
                        evaluation.feedbackMessage &&
                        evaluation.feedbackMessage.split(/\s+/).length > 15
                          ? "help"
                          : "default",
                    }}
                  >
                    {truncateMessage(evaluation.feedbackMessage)}
                  </td>
                  <td className="text-center">
                    {evaluation.createdAt
                      ? moment(evaluation.createdAt)
                          .utcOffset("+03:00")
                          .format("YYYY-MM-DD HH:mm")
                      : "-"}
                  </td>
                  <td className="text-center">
                    {(() => {
                      const chatId = getEvaluationChatId(evaluation)

                      return (
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => handleViewChat(evaluation)}
                          disabled={!chatId}
                          aria-label={`View chat for evaluation ${
                            evaluation.chat?.client || evaluation._id
                          }`}
                          title={
                            chatId ? "View Chat" : "Chat is not available"
                          }
                          style={{
                            padding: "4px 10px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <i className="mdi mdi-eye-outline"></i>
                          <span>View</span>
                        </button>
                      )
                    })()}
                  </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="7" className="text-center p-2">
                  No data found
                </td>
              </tr>
            </tbody>
          )}
        </table>
      )}
    </div>
  )
}
